import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { ErrorHandlerContext } from '@kinet-open-network/client/core/api-client';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerActions } from './+state/error-handler.actions';

export const errorHandlingInterceptor = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  let shouldIgnore: (res: HttpErrorResponse) => boolean = () => false;

  const ctx = request.context.get(ErrorHandlerContext);
  if (ctx) {
    if (typeof ctx === 'boolean' && ctx === true) {
      shouldIgnore = () => true;
    } else if (typeof ctx === 'object' && ctx.ignoreBelowStatus) {
      const ignoreBelowStatus = ctx.ignoreBelowStatus;
      shouldIgnore = (res: HttpErrorResponse) => {
        return res ? res.status < ignoreBelowStatus : false;
      };
    }
  }

  const store = inject(Store);

  return next(request).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse) {
        if (!shouldIgnore(error)) {
          store.dispatch(ErrorHandlerActions.throwError({ error }));
        }
      }

      return throwError(() => error);
    }),
  );
};
